import React from 'react'
import { Container } from './styles'
import { useGeneralHealthProcedures } from '~/context'
import { EMedicalViews, createSelectedPeriodFrom, PeriodOfTime } from '~/interfaces/timeline'
import {
  MedicalViewContentSelector,
  MedicalViewSelector,
  MedicalEventTypeFilter,
  CalendarFilter,
  TimelinePeriodSelector
} from '~/components/shared/medicalViews'
import { filterHealthProceduresTypesGeneral } from '~/constants/healthProceduresTypes'
import { SearchHealthProcedure } from '~/components/healthProcedures/SearchHealthProcedure'
import { Inline } from '~/styles'

export const GeneralHeader = (): JSX.Element => {
  const {
    selectedPeriod,
    mainContentType,
    changeMainContentType,
    displayedHealthProcedures,
    filterHealthProceduresByTerm,
    hasDateFiltersActive,
    dateFiltersActive,
    hasTypeFiltersActive,
    typeFiltersActive,
    updateSelectedPeriod,
    handleFilterHealthProceduresPerDate,
    handleFilterHealthProceduresPerType
  } = useGeneralHealthProcedures()

  return (
    <Container>
      <Inline width="100%" justifyContent="space-between">
        <Inline>
          <TimelinePeriodSelector
            value={selectedPeriod.period}
            onChange={value => updateSelectedPeriod({ ...createSelectedPeriodFrom(value as PeriodOfTime) })}
          />
          <MedicalViewContentSelector view={mainContentType} onChange={changeMainContentType} />
        </Inline>

        <Inline spacing="0.5rem">
          <MedicalViewSelector selectedMedicalView={EMedicalViews.GENERAL} />
          <MedicalEventTypeFilter
            options={filterHealthProceduresTypesGeneral}
            selected={typeFiltersActive}
            isActive={hasTypeFiltersActive}
            onChange={handleFilterHealthProceduresPerType}
          />
          <CalendarFilter
            dates={dateFiltersActive}
            isActive={hasDateFiltersActive}
            onChange={handleFilterHealthProceduresPerDate}
          />
        </Inline>
      </Inline>

      <SearchHealthProcedure options={displayedHealthProcedures} handleSearch={filterHealthProceduresByTerm} />
    </Container>
  )
}
